const translations = {
  'en-US' :{
    telemetryunavailablefirstgen: "Telemetry Readings Unavailable For First Generation Products",
    hidesitesnoreadings: "Hide sites with no readings",
    nositeswithreadings: "No sites with readings",
    allsystemsnormal: "All Systems Normal",
    nowarningsorfaults: "No warnings or faults reported.",
    nocurrentreadings: "No Current Readings",
    sitenotreportingtelemetry: "This site isn't reporting telemetry yet.",
    searching: "Searching",
    needsattention: "Needs attention",
    plusmore: "+%{count} more",
    greeting: "Hello",
    welcome: "Welcome",
    welcometoportal: "Welcome to",
    customerportal: "Customer Portal",
    home: "Home",
    systems: "Systems",
    notifications: "Notifications",
    notificationsettings: "Notification Settings",
    editusersettings: "Edit User Settings",
    nonotifications: "No Notifications",
    managecontacts: "Manage Contacts",
    sitemanagement: "Site Management",
    distributors: "Distributors",
    distributormanagement: "Distributor Management",
    customermaster: "Customer Master",
    location: "Location",
    invitedistributor: "Invite Distributor",
    revokedistributor: "Revoke distributor",
    revokedistributortitle: "Revoke distributor?",
    revokedistributortip: "Please confirm you are revoking %{name} as a distributor for %{master}.",
    errorrevokingdistributor: "Error revoking distributor. Please try again.",
    failedaddingdistributor: "Failed to add distributor. Please try again.",
    regiongroups: "Region Groups",
    regiongroupname: "Region group name",
    noregiongroups: "No region groups yet",
    create: "Create",
    add: "Add",
    addsite: "Add site",
    adddistributor: "Add distributor",
    nodistributorsinregion: "No distributors in this region group",
    deleteregiongroup: "Delete region group",
    deleteregiongrouptitle: "Delete region group?",
    deleteregiongrouptip: "Please confirm you are deleting the region group %{name}. Its sites will be unassigned.",
    nositesinregion: "No sites in this region group",
    nodistributorsavailable: "No distributors available",
    errorsavingregion: "Error saving changes. Please try again.",
    account: "Account",
    privacypolicy: "Privacy Policy",
    "privacy-policy": "Privacy Policy",
    settings: "Settings",
    email: "Email",
    emailaddress: "Email Address",
    password: "Password",
    rememberme: "Remember me",
    donthaveanaccount: "Don't have an account?",
    alreadyhaveanaccount: "Already have an account?",
    signup: "Sign Up",
    signin: "Sign In",
    signout: "Sign Out",
    back: "Back",
    done: "Done",
    usernameorpasswordincorrect: "Username or password incorrect. Please try again.",
    passwordincorrect: "Password incorrect. Please try again.",
    forgotpassword: "Forgot Password",
    register: "Register",
    name: "Name",
    phone: "Phone",
    firstname: "First Name",
    lastname: "Last Name",
    timezone: "Time Zone",
    selecttimezone: "Select Time Zone",
    save: "Save",
    saved: "Saved",
    notificationssettingssaved: "Notifications Settings Saved!",
    selectpreferredtimezone: "Select Preferred Time Zone",
    onlyalphabet: "Only alphabetical characters allowed.",
    entervalidphone: "Enter valid phone number.",
    enterregistrationcode: "Please enter the registration code from Fire Rover.",
    registersuccess: "Registered successfully!",
    registerfailed: "Error registering. Please try again.",
    resetpassword: "Reset Password",
    reset: "Reset",
    enternewpassword: "Enter New Password",
    changepassword: "Change Password",
    currentpassword: "Current Password",
    newpassword: "New Password",
    confirmpassword: "Confirm Password",
    validatepassword: "Validate Password",
    passwordsdonotmatch: "Passwords do not match.",
    registrationcode: "Registration Code",
    addregistrationcodes: "Add Registration Codes:",
    registrationcomplete: "Registration complete! You will now be redirected to the sign in page.",
    addcode: "Add Code",
    validatecode: "Validate Code",
    codevalidated: "Code Validated",
    codeverified: "Code Verified!",
    codevalidatefailed: "Invalid code. Please try again.",
    sendcode: "Send Code",
    resendcode: "Resend Code",
    phoneverificationcode: "Phone Verification Code",
    enterverificationcode: "Please enter the verification code sent to your mobile device.",
    enteremailverificationcode: "Please enter the verification code sent to your Email.",
    enteremailforresetcode: "Please enter your email address to recieve a reset code.",
    verificationcodesent: "Verification code sent!",
    checkforverificationcode: "Please check your text messages for the verification code.",
    accountcreatedcheckforcode: "Your account has been created, but you will not recieve notifications until your phone number is verified.",
    verificationcodesentfailure: "Error sending verification code. Please try again.",
    emailisinvalid: "Email is invalid.",
    passwordresetsuccess: "Password reset successfully!",
    passwordresetfailed: "Could not reset password. Please try again.",
    passwordchangefailed: "Could not change password. Please try again.",
    passwordrequirementstxt: "Password must be between 8 and 26 characters long, have at least 1 capital letter, 1 lowercase letter, 1 number, and 1 special character.",
    contacts: "Contacts",
    nocontacts: "No Contacts",
    invitecontactuser: "Invite Contact User",
    personalinformation: "Personal Information",
    inputemail: "Input Email",
    requestpasswordreset: "Request Password Reset",
    search: "Search",
    sitesmanagement: "Sites Management",
    sites: "Sites",
    retrievingsites: "Retrieving Sites",
    retrievingnotifications: "Retrieving Notifications",
    nositesfound: "No Sites Found",
    address: "Address",
    state: "State",
    units: "Units",
    unit: "Unit",
    site: "Site",
    date: "Date",
    systemtime: "System Time",
    localtime: "Local Time",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    promotetomanager: "Promote to Manager",
    promoteusertositemanager: "Promote user to site manager?",
    promoteusertositemanagertip: "Please confirm you are promoting %{name} to a manager for %{site}.",
    demotemanager: "Demote Manager",
    demotemanagertouser: "Demote Manager to User",
    demotesitemanagertouser: "Demote site manager to user?",
    demotesitemanagertousertip: "Please confirm you are demoting %{name} to a user for %{site}.",
    deleteuser: "Delete User",
    removeuser: "Remove User",
    removeuserfromsite: "Remove user from site?",
    removeuserfromsitetip: "Please confirm you are removing %{name} from %{site}.",
    todcontrolinfo: "Time of Day Control Info",
    todcontrolinfotip: "Settings for weekdays and weekends are independent and can be the same or different for both.",
    on247: "On 24/7",
    on247info: "You will receive notifications in real time 24/7.",
    off: "Off",
    offinfo: "You will not receive notifications at any time regardless of Alert and Notification Settings.",
    onperschedule: "On Per Schedule",
    accumulation: "Accumulation",
    accumulationinfo: "Notifications received during off hours will be held and delivered in bulk at the start of the next operational period.",
    startstop: "Start/Stop",
    startstopinfo: "Notifications received during off hours will not be delivered but will be stored in archive.",
    invitesent: "Invite Sent!",
    invitefailed: "Error sending invite. Please try again.",
    inviteuser: "Invite User",
    invitecontactforsite: "Invite Contact for Site",
    sendinvite: "Send Invite",
    testalert: "TEST ALERT",
    testalerts: "Test Alerts",
    hidetestalerts: "Hide Test Alerts",
    fireroveractivated: "Fire Rover Activated",
    accountmanager: "Account Manager",
    accountmanagerphone: "Account Manager Phone",
    centralstation: "Central Station",
    centralstationphone: "Central Station Phone",
    servicedepartmentphone: "Service Department Phone",
    alertsiwanttoreceive: "Alerts I Want to Receive",
    verifiedfire: "Verified Fire - System Prepared for Engagement",
    suppressionactivated: "Suppression Activated",
    mobilesuppressionunit: "Mobile Suppression Unit - Mode Changes",
    alertdeliverymethods: "Alert Delivery Methods",
    fireroverappnotifications: "Firerover App Notifications",
    textnotifications: "Text Notifications",
    whatsappnotifications: "WhatsApp Notifications",
    pushnotifications: "Push Notifications",
    emailnotifications: "Email Notifications",
    wheniwanttoreceivealerts: "When I Want to Receive Alerts",
    weekdays: "Weekdays",
    weekends: "Weekends",
    starttime: "Start Time",
    endtime: "End Time",
    preferredlanguage: "Preferred Language",
    preferredlanguageNote: "*Impacts notifications only",
    selectpreferredlanguage: "Select Preferred Language",
    selectlanguage: "Select Language",
    smsenabled: "Text Notifications Enabled",
    messageratesmayapply: "Message & data rates may apply.",
    whatsappconsenttitle: "WhatsApp Consent Required",
    whatsappconsenttip: "To receive alerts through WhatsApp, we need your consent to message you at your phone number on file. Message & data rates may apply. You can turn WhatsApp notifications off at any time.",
    whatsappconsentcheckbox: "I consent to receiving messages from Fire Rover through WhatsApp.",
    sendcodevia: "Send my verification code via",
    textmessage: "Text Message",
    whatsapp: "WhatsApp",
    verifyphone: "Verify Phone",
    phoneverifiedsuccess: "Your phone number is verified.",
    phonenotverified: "Phone Not Verified",
    phonenotverifiedwarning: "Your phone number is not verified. Click here to verify it. Until it is verified, we can't guarantee you will receive any messages sent by text.",
    phoneverificationrequired: "Phone Verification Required",
    registrationincomplete: "Your phone number was never verified, so your registration was not completed. Please register again below to receive a new verification code.",
    codeinvalidorexpired: "Code is invalid or expired. Codes expire 2 minutes after they are sent.",
    phonenumbermismatch: "This phone number does not match the one saved on your account. Save your new number first, then request a code.",
    usernotfound: "We couldn't find an account for that email address.",
    sendcodeunexpected: "We couldn't request a code. Please contact support if this keeps happening.",
    verifyphoneprompt: "Send a verification code to your phone number, then enter it below.",
    codesentcheckmessages: "Check your messages for the verification code and enter it below.",
    skipfornow: "Skip for Now",
    termsofservice: "Terms of Service",
    accept: "Accept",
    english: "English",
    french: "French",
    spanish: "Spanish",
    internalusers: "Internal Users",
    event: "Event",
    showmore: "Show More",
    send: "Send",
    actions: "Actions",
    userdoesnotexist: "User does not exist. Please try again.",
    rowsperpage: "Rows per page",
    noimage: "No Image",
    healthdashboard: "Health Dashboard",
    alerts: "Alerts",
    overview: "Overview",
    diagnostics: "Diagnostics",
    viewallalerts: "View All Alerts",
    unabletoloadalerts: "Unable To Load Alerts",
    unabletoloadsystems: "Unable To Load Systems",
    unabletoloadsites: "Unable To Load Sites",
    unabletoloaddetail: "Unable To Load Detail",
    searchbysiteorsystem: "Search by site or system name",
    closealertsdrawer: "Close all alerts drawer",
    closesystemsdrawer: "Close systems drawer",
    closesystemdetail: "Close system detail",

    // Material React Table
    and: 'and',
    changeFilterMode: 'Change filter mode',
    changeSearchMode: 'Change search mode',
    clearFilter: 'Clear filter',
    clearSearch: 'Clear search',
    clearSelection: 'Clear selection',
    clearSort: 'Clear sort',
    clickToCopy: 'Click to copy',
    copy: 'Copy',
    collapse: 'Collapse',
    collapseAll: 'Collapse all',
    columnActions: 'Column Actions',
    copiedToClipboard: 'Copied to clipboard',
    dropToGroupBy: 'Drop to group by {column}',
    edit: 'Edit',
    expand: 'Expand',
    expandAll: 'Expand all',
    filterArrIncludes: 'Includes',
    filterArrIncludesAll: 'Includes all',
    filterArrIncludesSome: 'Includes',
    filterBetween: 'Between',
    filterBetweenInclusive: 'Between Inclusive',
    filterByColumn: 'Filter by {column}',
    filterContains: 'Contains',
    filterEmpty: 'Empty',
    filterEndsWith: 'Ends With',
    filterEquals: 'Equals',
    filterEqualsString: 'Equals',
    filterFuzzy: 'Fuzzy',
    filterGreaterThan: 'Greater Than',
    filterGreaterThanOrEqualTo: 'Greater Than Or Equal To',
    filterInNumberRange: 'Between',
    filterIncludesString: 'Contains',
    filterIncludesStringSensitive: 'Contains',
    filterLessThan: 'Less Than',
    filterLessThanOrEqualTo: 'Less Than Or Equal To',
    filterMode: 'Filter Mode: {filterType}',
    filterNotEmpty: 'Not Empty',
    filterNotEquals: 'Not Equals',
    filterStartsWith: 'Starts With',
    filterWeakEquals: 'Equals',
    filteringByColumn: 'Filtering by {column} - {filterType} {filterValue}',
    goToFirstPage: 'Go to first page',
    goToLastPage: 'Go to last page',
    goToNextPage: 'Go to next page',
    goToPreviousPage: 'Go to previous page',
    grab: 'Grab',
    groupByColumn: 'Group by {column}',
    groupedBy: 'Grouped by ',
    hideAll: 'Hide all',
    hideColumn: 'Hide {column} column',
    max: 'Max',
    min: 'Min',
    move: 'Move',
    noRecordsToDisplay: 'No records to display',
    noResultsFound: 'No results found',
    of: 'of',
    or: 'or',
    pin: 'Pin',
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    resetColumnSize: 'Reset column size',
    resetOrder: 'Reset order',
    rowActions: 'Row Actions',
    rowNumber: '#',
    rowNumbers: 'Row Numbers',
    select: 'Select',
    selectedCountOfRowCountRowsSelected: '{selectedCount} of {rowCount} row(s) selected',
    showAll: 'Show all',
    showAllColumns: 'Show all columns',
    showHideColumns: 'Show/Hide columns',
    showHideFilters: 'Show/Hide filters',
    showHideSearch: 'Show/Hide search',
    sortByColumnAsc: 'Sort by {column} ascending',
    sortByColumnDesc: 'Sort by {column} descending',
    sortedByColumnAsc: 'Sorted by {column} ascending',
    sortedByColumnDesc: 'Sorted by {column} descending',
    thenBy: ', then by ',
    toggleDensity: 'Toggle density',
    toggleFullScreen: 'Toggle full screen',
    toggleSelectAll: 'Toggle select all',
    toggleSelectRow: 'Toggle select row',
    toggleVisibility: 'Toggle visibility',
    ungroupByColumn: 'Ungroup by {column}',
    unpin: 'Unpin',
    unpinAll: 'Unpin all',

    wt_step: "Step %{current} / %{total}",
    wt_skip: "Skip",
    wt_previous: "Previous",
    wt_next: "Next",
    wt_allset: "All set",
    wt_replay: "Replay walkthrough",
    wt_demo_event_title: "Spray-On",
    wt_demo_event_subtitle: "Sample Site · Unit 01",
    wt_demo_event_time: "Today, 9:42 AM (sample event)",
    wt_welcome_title: "Welcome to the portal",
    wt_welcome_body: "We'll take a quick tour of the screens you'll use most. You can skip at any time.",
    wt_healthdashboard_title: "Health Dashboard",
    wt_healthdashboard_body: "Start here for the live status of your systems. Alerts needing attention are listed at the top, and you can look up any site to check a system's connection, power, suppressant, and detector signals.",
    wt_tile_title: "Notification tile",
    wt_tile_body: "Each event your sites send shows up as a tile like this one, with the type, site, and time at a glance.",
    wt_image_title: "Event imagery",
    wt_image_body: "Tap or click the image on a notification to enlarge it for a closer look.",
    wt_menu_title: "Main menu",
    wt_menu_body: "Open the side menu from the top-left at any time to jump between screens.",
    wt_distributors_title: "Distributor Management",
    wt_distributors_body: "Assign managers to the sites and regions they oversee so they can then assign the users responsible for monitoring those sites.",
    wt_managecontacts_title: "Manage Users",
    wt_managecontacts_body: "Site managers, internal users, and distributors can manage the sites and users they oversee here.",
    wt_sitecontacts_title: "Site Users",
    wt_sitecontacts_body: "Open any site to see the people associated with it and adjust who receives notifications.",
    wt_account_title: "Your account",
    wt_account_body: "Update your name, phone, time zone, and password here. You can also add registration codes for new units.",
    wt_settings_title: "Notification settings",
    wt_settings_body: "Choose how each notification type reaches you. From here you can adjust:",
    wt_settings_item1: "Push notifications on the web and mobile",
    wt_settings_item2: "Email notifications",
    wt_settings_item3: "Text (SMS) notifications",
    wt_settings_item4: "WhatsApp notifications",
    wt_settings_item5: "Quiet hours and per-site preferences",
    wt_settings_whatsapp_note: "Note: international users may have trouble receiving text (SMS) alerts. If you're outside the United States, consider choosing WhatsApp notifications instead so your alert messages reach you.",
    wt_complete_title: "You're all set",
    wt_complete_body: "That's everything for now. You can replay this walkthrough from the Account screen whenever you'd like.",

    sig_monitoring: "Monitoring Connection",
    sig_primary: "Primary Network",
    sig_cellular: "Cellular Backup",
    sig_ac: "AC Power",
    sig_battery: "Backup Battery",
    sig_suppressant: "Suppressant Level",
    sig_nitrogen: "Nitrogen Pressure",
    sig_thermal: "Thermal Detector",
    sig_flame: "Flame Detector",
    sig_climate: "Enclosure Climate",
    sig_supervisory: "Supervisory",
    sig_ebutton: "Emergency Button",

    state_ok: "Healthy",
    state_warn: "Warning",
    state_fault: "Fault",
    state_unknown: "Unknown",

    st_online: "ONLINE",
    st_offline: "OFFLINE",
    st_connected: "CONNECTED",
    st_down: "DOWN",
    st_lost: "LOST",
    st_standby: "STANDBY",
    st_onbattery: "ON BATTERY",
    st_normal: "NORMAL",
    st_tempalarm: "TEMP ALARM",
    st_outofrange: "OUT OF RANGE",
    st_unknown: "UNKNOWN",

    loading: "Loading…",
    allsystemsok: "All Systems OK",
    faultneedsattention: "1 Fault Needs Attention",
    faultsneedattention: "%{count} Faults Need Attention",
    onewarning: "1 Warning",
    warningscount: "%{count} Warnings",

    noreadingyet: "No reading yet",
    stalelastreading: "Stale · Last reading %{time}",
    ago_seconds: "%{count}s ago",
    ago_minutes: "%{count}m ago",
    ago_hours: "%{count}h ago",
    ago_days: "%{count}d ago",

    networkerror: "Network error",
    serverresponded: "Server responded with %{status} %{text}",
    viewallsystems: "View all %{count} systems",
    nositesmatch: "No sites match \"%{query}\"",
    lastupdatedtime: "Last updated %{time}",
    dragtorotate: "Drag to rotate · Highlighted area shows where the issue is",
    awarenessonly: "Awareness only · Contact FireRover support for service.",
    livereconnecting: "Reconnecting…",
    liveconnecting: "Connecting…",
    liveoffline: "Offline"
  },

  'fr-FR' :{
    telemetryunavailablefirstgen: "Relevés de télémétrie non disponibles pour les produits de première génération",
    hidesitesnoreadings: "Masquer les sites sans relevés",
    nositeswithreadings: "Aucun site avec relevés",
    allsystemsnormal: "Tous les systèmes normaux",
    nowarningsorfaults: "Aucun avertissement ni défaut signalé.",
    nocurrentreadings: "Aucun relevé actuel",
    sitenotreportingtelemetry: "Ce site ne transmet pas encore de télémétrie.",
    searching: "Recherche…",
    needsattention: "Nécessite une attention",
    plusmore: "+%{count} de plus",
    greeting: "Bonjour",
    welcome: "Bienvenue",
    welcometoportal: "Bienvenue sur le Portail Client",
    customerportal: "Portail du Web ",
    home: "Accueil",
    systems: "Systèmes",
    notifications: "Notifications",
    notificationsettings: "Paramètres de notification",
    editusersettings: "Modifier les paramètres utilisateur",
    nonotifications: "Aucune notification",
    managecontacts: "Gérer les contacts",
    sitemanagement: "Gestion du site",
    distributors: "Distributeurs",
    distributormanagement: "Gestion des distributeurs",
    customermaster: "Client principal",
    location: "Emplacement",
    invitedistributor: "Inviter un distributeur",
    revokedistributor: "Révoquer le distributeur",
    revokedistributortitle: "Révoquer le distributeur ?",
    revokedistributortip: "Veuillez confirmer que vous révoquez %{name} en tant que distributeur pour %{master}.",
    errorrevokingdistributor: "Erreur lors de la révocation du distributeur. Veuillez réessayer.",
    failedaddingdistributor: "Échec de l'ajout du distributeur. Veuillez réessayer.",
    regiongroups: "Groupes de régions",
    regiongroupname: "Nom du groupe de régions",
    noregiongroups: "Aucun groupe de régions pour l'instant",
    create: "Créer",
    add: "Ajouter",
    addsite: "Ajouter un site",
    adddistributor: "Ajouter un distributeur",
    nodistributorsinregion: "Aucun distributeur dans ce groupe de régions",
    deleteregiongroup: "Supprimer le groupe de régions",
    deleteregiongrouptitle: "Supprimer le groupe de régions ?",
    deleteregiongrouptip: "Veuillez confirmer la suppression du groupe de régions %{name}. Ses sites seront désassignés.",
    nositesinregion: "Aucun site dans ce groupe de régions",
    nodistributorsavailable: "Aucun distributeur disponible",
    errorsavingregion: "Erreur lors de l'enregistrement. Veuillez réessayer.",
    account: "Compte",
    privacypolicy: "Politique de confidentialité",
    "privacy-policy": "Politique de confidentialité",
    settings: "Paramètres",
    email: "Email",
    emailaddress: "Email",
    password: "Mot de passe",
    rememberme: "Se souvenir de moi",
    donthaveanaccount: "Vous n'avez pas de compte?",
    alreadyhaveanaccount: "Vous avez déjà un compte?",
    signup: "S’inscrire",
    signin: "Se connecter",
    signout: "Se déconnecter",
    back: "Retour",
    done: "Terminé",
    usernameorpasswordincorrect: "Nom d'utilisateur ou mot de passe incorrect. Veuillez réessayer.",
    passwordincorrect: "Mot de passe incorrect. Veuillez réessayer.",
    forgotpassword: "Mot de passe oublié",
    register: "S'inscrire",
    name: "Nom",
    phone: "Téléphone",
    firstname: "Prénom",
    lastname: "Nom de famille",
    timezone: "Fuseau horaire",
    selecttimezone: "Sélectionner le fuseau horaire",
    save: "Enregistrer",
    saved: "Enregistré",
    notificationssettingssaved: "Paramètres de notification enregistrés!",
    selectpreferredtimezone: "Sélectionner le fuseau horaire préféré",
    onlyalphabet: "Seuls les caractères alphabétiques sont autorisés.",
    entervalidphone: "Entrez un numéro de téléphone valide.",
    enterregistrationcode: "Veuillez entrer le code d'inscription de Fire Rover.",
    registersuccess: "Inscription réussie !",
    registerfailed: "Erreur lors de l'inscription. Veuillez réessayer.",
    resetpassword: "Réinitialiser le mot de passe",
    reset: "Réinitialiser",
    enternewpassword: "Entrez un nouveau mot de passe",
    changepassword: "Changer le mot de passe",
    currentpassword: "Mot de passe actuel",
    newpassword: "Nouveau mot de passe",
    confirmpassword: "Confirmer le mot de passe",
    validatepassword: "Valider le mot de passe",
    passwordsdonotmatch: "Les mots de passe ne correspondent pas.",
    registrationcode: "Code d'inscription",
    addregistrationcodes: "Ajouter des codes d'inscription:",
    registrationcomplete: "Inscription terminée ! Vous allez maintenant être redirigé vers la page de connexion.",
    addcode: "Ajouter un code",
    validatecode: "Valider le code",
    codevalidated: "Code validé",
    codeverified: "Code vérifié!",
    codevalidatefailed: "Code invalide. Veuillez réessayer.",
    sendcode: "Envoyer le code",
    resendcode: "Renvoyer le code",
    phoneverificationcode: "Code de vérification téléphonique",
    enterverificationcode: "Veuillez entrer le code de vérification envoyé à votre appareil mobile.",
    enteremailverificationcode: "Veuillez entrer le code de vérification envoyé à votre e-mail.",
    enteremailforresetcode: "Veuillez entrer votre adresse e-mail pour recevoir un code de réinitialisation.",
    verificationcodesent: "Code de vérification envoyé!",
    checkforverificationcode: "Veuillez vérifier vos messages texte pour le code de vérification.",
    accountcreatedcheckforcode: "Votre compte a été créé, mais vous ne recevrez pas de notifications tant que votre numéro de téléphone n’aura pas été vérifié.",
    verificationcodesentfailure: "Erreur lors de l’envoi du code de vérification. Veuillez réessayer.",
    emailisinvalid: "L'email est invalide.",
    passwordresetsuccess: "Mot de passe réinitialisé avec succès !",
    passwordresetfailed: "Impossible de réinitialiser le mot de passe. Veuillez réessayer.",
    passwordchangefailed: "Impossible de changer le mot de passe. Veuillez réessayer.",
    passwordrequirementstxt: "Le mot de passe doit contenir entre 8 et 26 caractères, inclure au moins 1 lettre majuscule, 1 lettre minuscule, 1 chiffre et 1 caractère spécial.",
    contacts: "Contacts",
    nocontacts: "Aucun contact",
    invitecontactuser: "Inviter un contact",
    personalinformation: "Informations personnelles",
    inputemail: "Saisir l'email",
    requestpasswordreset: "Demander la réinitialisation du mot de passe",
    search: "Rechercher",
    sitesmanagement: "Gestion des sites",
    sites: "Sites",
    retrievingsites: "Récupération des sites",
    retrievingnotifications: "Récupération des notifications",
    nositesfound: "Aucun site trouvé",
    address: "Adresse",
    state: "État",
    units: "Unités",
    unit: "Unité",
    site: "Site",
    date: "Date",
    systemtime: "Heure du système",
    localtime: "Heure locale",
    confirm: "Confirmer",
    cancel: "Annuler",
    close: "Fermer",
    delete: "Supprimer",
    promotetomanager: "Promouvoir au poste de responsable",
    promoteusertositemanager: "Promouvoir l’utilisateur en gestionnaire de site?",
    promoteusertositemanagertip: "Veuillez confirmer que vous promouvez %{name} au poste de gestionnaire pour %{site}.",
    demotemanager: "Rétrograder le responsable",
    demotemanagertouser: "Rétrograder le responsable en utilisateur",
    demotesitemanagertouser: "Rétrograder le gestionnaire de site en utilisateur?",
    demotesitemanagertousertip: "Veuillez confirmer que vous rétrogradez %{name} au rôle d’utilisateur pour %{site}.",
    deleteuser: "Supprimer l'utilisateur",
    removeuser: "Supprimer l’utilisateur",
    removeuserfromsite: "Supprimer l’utilisateur du site?",
    removeuserfromsitetip: "Veuillez confirmer que vous supprimez %{name} de %{site}.",
    todcontrolinfo: "Informations sur le contrôle horaire",
    todcontrolinfotip: "Les réglages des jours de semaine et des week-ends sont indépendants et peuvent être identiques ou différents.",
    on247: "Actif 24h/24 et 7j/7",
    on247info: "Vous recevrez des notifications en temps réel 24h/24 et 7j/7.",
    off: "Inactif",
    offinfo: "Vous ne recevrez aucune notification, peu importe les paramètres d'alerte.",
    onperschedule: "Actif selon le planning",
    accumulation: "Accumulation",
    accumulationinfo: "Les notifications reçues en dehors des heures d'activité seront regroupées et envoyées au début de la prochaine période opérationnelle.",
    startstop: "Démarrer/Arrêter",
    startstopinfo: "Les notifications reçues en dehors des heures d'activité ne seront pas envoyées mais archivées.",
    invitesent: "Invitation envoyée !",
    invitefailed: "Erreur lors de l'envoi de l'invitation. Veuillez réessayer.",
    inviteuser: "Inviter un utilisateur",
    invitecontactforsite: "Inviter un contact pour le site",
    sendinvite: "Envoyer l'invitation",
    testalert: "ALERTE TEST",
    testalerts: "Alertes test",
    hidetestalerts: "Masquer les alertes test",
    fireroveractivated: "Fire Rover activé",
    accountmanager: "Gestionnaire de compte",
    accountmanagerphone: "Téléphone du gestionnaire de compte",
    centralstation: "Station centrale",
    centralstationphone: "Téléphone de la station centrale",
    servicedepartmentphone: "Téléphone du service technique",
    alertsiwanttoreceive: "Alertes que je souhaite recevoir",
    verifiedfire: "Incendie vérifié - Système prêt à intervenir",
    suppressionactivated: "Extinction activée",
    mobilesuppressionunit: "Unité mobile de suppression - Changement de mode",
    alertdeliverymethods: "Méthodes de livraison des alertes",
    fireroverappnotifications: "Notifications de l'application FireRover",
    textnotifications: "Notifications texte",
    whatsappnotifications: "Notifications WhatsApp",
    pushnotifications: "Notifications push",
    emailnotifications: "Notifications par email",
    wheniwanttoreceivealerts: "Quand je souhaite recevoir les alertes",
    weekdays: "Jours de semaine",
    weekends: "Week-ends",
    starttime: "Heure de début",
    endtime: "Heure de fin",
    preferredlanguage: "Langue préférée",
    preferredlanguageNote: "*Affecte uniquement les notifications",
    selectpreferredlanguage: "Sélectionner la langue préférée",
    selectlanguage: "Sélectionner la langue",
    smsenabled: "Notifications texte activés",
    messageratesmayapply: "Des frais de messagerie peuvent s'appliquer. Les SMS peuvent ne pas être disponibles dans votre pays.",
    whatsappconsenttitle: "Consentement WhatsApp requis",
    whatsappconsenttip: "Pour recevoir des alertes via WhatsApp, nous avons besoin de votre consentement afin de vous envoyer des messages au numéro de téléphone enregistré. Des frais de messagerie peuvent s'appliquer. Vous pouvez désactiver les notifications WhatsApp à tout moment.",
    whatsappconsentcheckbox: "Je consens à recevoir des messages de Fire Rover via WhatsApp.",
    sendcodevia: "Envoyer mon code de vérification par",
    textmessage: "Message texte",
    whatsapp: "WhatsApp",
    verifyphone: "Vérifier le téléphone",
    phoneverifiedsuccess: "Votre numéro de téléphone est vérifié.",
    phonenotverified: "Téléphone non vérifié",
    phonenotverifiedwarning: "Votre numéro de téléphone n'est pas vérifié. Cliquez ici pour le vérifier. Tant qu'il n'est pas vérifié, nous ne pouvons pas garantir que vous recevrez les messages envoyés par texto.",
    phoneverificationrequired: "Vérification du téléphone requise",
    registrationincomplete: "Votre numéro de téléphone n'a jamais été vérifié, votre inscription n'a donc pas été complétée. Veuillez vous inscrire à nouveau ci-dessous pour recevoir un nouveau code de vérification.",
    codeinvalidorexpired: "Le code est invalide ou expiré. Les codes expirent 2 minutes après leur envoi.",
    phonenumbermismatch: "Ce numéro de téléphone ne correspond pas à celui enregistré sur votre compte. Enregistrez d'abord votre nouveau numéro, puis demandez un code.",
    usernotfound: "Nous n'avons trouvé aucun compte pour cette adresse courriel.",
    sendcodeunexpected: "Nous n'avons pas pu demander de code. Veuillez contacter le soutien technique si le problème persiste.",
    verifyphoneprompt: "Envoyez un code de vérification à votre numéro de téléphone, puis saisissez-le ci-dessous.",
    codesentcheckmessages: "Consultez vos messages pour obtenir le code de vérification et saisissez-le ci-dessous.",
    skipfornow: "Ignorer pour l'instant",
    termsofservice: "Conditions d'utilisation",
    accept: "Accepter",
    english: "Anglais",
    french: "Français",
    spanish: "Espagnol",
    internalusers: "Utilisateurs internes",
    event: "Événement",
    showmore: "Afficher plus",
    send: "Envoyer",
    actions: "Actions",
    userdoesnotexist: "L’utilisateur n’existe pas. Veuillez réessayer.",
    rowsperpage: "Lignes par page",
    noimage: "Aucune Image",
    healthdashboard: "Tableau de bord de santé",
    alerts: "Alertes",
    overview: "Aperçu",
    diagnostics: "Diagnostics",
    viewallalerts: "Voir toutes les alertes",
    unabletoloadalerts: "Impossible de charger les alertes",
    unabletoloadsystems: "Impossible de charger les systèmes",
    unabletoloadsites: "Impossible de charger les sites",
    unabletoloaddetail: "Impossible de charger les détails",
    searchbysiteorsystem: "Rechercher par nom de site ou de système",
    closealertsdrawer: "Fermer le panneau des alertes",
    closesystemsdrawer: "Fermer le panneau des systèmes",
    closesystemdetail: "Fermer les détails du système",

    // Material React Table
    and: 'et',
    changeFilterMode: 'Changer le mode de filtre',
    changeSearchMode: 'Changer le mode de recherche',
    clearFilter: 'Effacer le filtre',
    clearSearch: 'Effacer la recherche',
    clearSelection: 'Effacer la sélection',
    clearSort: 'Effacer le tri',
    clickToCopy: 'Cliquer pour copier',
    copy: 'Copier',
    collapse: 'Réduire',
    collapseAll: 'Tout réduire',
    columnActions: 'Actions de colonne',
    copiedToClipboard: 'Copié dans le presse-papiers',
    dropToGroupBy: 'Déposer pour grouper par {column}',
    edit: 'Modifier',
    expand: 'Développer',
    expandAll: 'Tout développer',
    filterArrIncludes: 'Inclut',
    filterArrIncludesAll: 'Inclut tout',
    filterArrIncludesSome: 'Inclut',
    filterBetween: 'Entre',
    filterBetweenInclusive: 'Entre (inclusif)',
    filterByColumn: 'Filtrer par {column}',
    filterContains: 'Contient',
    filterEmpty: 'Vide',
    filterEndsWith: 'Se termine par',
    filterEquals: 'Égal à',
    filterEqualsString: 'Égal à',
    filterFuzzy: 'Approximatif',
    filterGreaterThan: 'Supérieur à',
    filterGreaterThanOrEqualTo: 'Supérieur ou égal à',
    filterInNumberRange: 'Entre',
    filterIncludesString: 'Contient',
    filterIncludesStringSensitive: 'Contient',
    filterLessThan: 'Inférieur à',
    filterLessThanOrEqualTo: 'Inférieur ou égal à',
    filterMode: 'Mode de filtre : {filterType}',
    filterNotEmpty: 'Non vide',
    filterNotEquals: 'Différent de',
    filterStartsWith: 'Commence par',
    filterWeakEquals: 'Égal à',
    filteringByColumn: 'Filtrage par {column} - {filterType} {filterValue}',
    goToFirstPage: 'Aller à la première page',
    goToLastPage: 'Aller à la dernière page',
    goToNextPage: 'Aller à la page suivante',
    goToPreviousPage: 'Aller à la page précédente',
    grab: 'Saisir',
    groupByColumn: 'Grouper par {column}',
    groupedBy: 'Groupé par ',
    hideAll: 'Tout masquer',
    hideColumn: 'Masquer la colonne {column}',
    max: 'Max',
    min: 'Min',
    move: 'Déplacer',
    noRecordsToDisplay: 'Aucun enregistrement à afficher',
    noResultsFound: 'Aucun résultat trouvé',
    of: 'sur',
    or: 'ou',
    pin: 'Épingler',
    pinToLeft: 'Épingler à gauche',
    pinToRight: 'Épingler à droite',
    resetColumnSize: 'Réinitialiser la taille de colonne',
    resetOrder: 'Réinitialiser l\'ordre',
    rowActions: 'Actions de ligne',
    rowNumber: '#',
    rowNumbers: 'Numéros de ligne',
    select: 'Sélectionner',
    selectedCountOfRowCountRowsSelected: '{selectedCount} sur {rowCount} ligne(s) sélectionnée(s)',
    showAll: 'Tout afficher',
    showAllColumns: 'Afficher toutes les colonnes',
    showHideColumns: 'Afficher/Masquer les colonnes',
    showHideFilters: 'Afficher/Masquer les filtres',
    showHideSearch: 'Afficher/Masquer la recherche',
    sortByColumnAsc: 'Trier par {column} croissant',
    sortByColumnDesc: 'Trier par {column} décroissant',
    sortedByColumnAsc: 'Trié par {column} croissant',
    sortedByColumnDesc: 'Trié par {column} décroissant',
    thenBy: ', puis par ',
    toggleDensity: 'Basculer la densité',
    toggleFullScreen: 'Basculer en plein écran',
    toggleSelectAll: 'Basculer tout sélectionner',
    toggleSelectRow: 'Basculer sélection ligne',
    toggleVisibility: 'Basculer la visibilité',
    ungroupByColumn: 'Dégrouper par {column}',
    unpin: 'Désépingler',
    unpinAll: 'Tout désépingler',

    wt_step: "Étape %{current} / %{total}",
    wt_skip: "Passer",
    wt_previous: "Précédent",
    wt_next: "Suivant",
    wt_allset: "Terminé",
    wt_replay: "Revoir le tutoriel",
    wt_demo_event_title: "Spray-On",
    wt_demo_event_subtitle: "Site d'exemple · Unité 01",
    wt_demo_event_time: "Aujourd'hui, 09h42 (événement d'exemple)",
    wt_welcome_title: "Bienvenue sur le portail",
    wt_welcome_body: "Nous allons faire un tour rapide des écrans que vous utiliserez le plus. Vous pouvez passer à tout moment.",
    wt_healthdashboard_title: "Tableau de bord de santé",
    wt_healthdashboard_body: "Commencez ici pour connaître l'état en direct de vos systèmes. Les alertes nécessitant votre attention figurent en haut, et vous pouvez rechercher n'importe quel site pour vérifier la connexion, l'alimentation, le niveau d'agent extincteur et les détecteurs d'un système.",
    wt_tile_title: "Vignette de notification",
    wt_tile_body: "Chaque événement envoyé par vos sites apparaît sous forme de vignette comme celle-ci, avec le type, le site et l'heure.",
    wt_image_title: "Images d'événement",
    wt_image_body: "Cliquez sur l'image d'une notification pour l'agrandir et la voir en détail.",
    wt_menu_title: "Menu principal",
    wt_menu_body: "Ouvrez le menu latéral depuis le coin supérieur gauche pour passer d'un écran à l'autre.",
    wt_distributors_title: "Gestion des distributeurs",
    wt_distributors_body: "Attribuez les responsables aux sites et aux régions qu'ils supervisent afin qu'ils puissent ensuite attribuer les utilisateurs chargés de la surveillance de ces sites.",
    wt_managecontacts_title: "Gérer les utilisateurs",
    wt_managecontacts_body: "Les responsables de site, les utilisateurs internes et les distributeurs peuvent gérer leurs sites et leurs utilisateurs ici.",
    wt_sitecontacts_title: "Utilisateurs du site",
    wt_sitecontacts_body: "Ouvrez un site pour voir les personnes associées et ajuster qui reçoit les notifications.",
    wt_account_title: "Votre compte",
    wt_account_body: "Mettez à jour votre nom, téléphone, fuseau horaire et mot de passe ici. Vous pouvez aussi ajouter des codes d'enregistrement.",
    wt_settings_title: "Paramètres de notification",
    wt_settings_body: "Choisissez comment chaque type de notification vous parvient. Depuis cet écran vous pouvez ajuster :",
    wt_settings_item1: "Notifications push sur le web et mobile",
    wt_settings_item2: "Notifications par e-mail",
    wt_settings_item3: "Notifications par SMS",
    wt_settings_item4: "Notifications WhatsApp",
    wt_settings_item5: "Heures de silence et préférences par site",
    wt_settings_whatsapp_note: "Remarque : les utilisateurs internationaux peuvent avoir des difficultés à recevoir les alertes par SMS. Si vous êtes en dehors des États-Unis, envisagez de choisir plutôt les notifications WhatsApp afin de bien recevoir vos messages d'alerte.",
    wt_complete_title: "Tout est prêt",
    wt_complete_body: "C'est tout pour l'instant. Vous pouvez revoir ce tutoriel depuis l'écran Compte à tout moment.",

    sig_monitoring: "Connexion de surveillance",
    sig_primary: "Réseau principal",
    sig_cellular: "Secours cellulaire",
    sig_ac: "Alimentation secteur",
    sig_battery: "Batterie de secours",
    sig_suppressant: "Niveau d'agent extincteur",
    sig_nitrogen: "Pression d'azote",
    sig_thermal: "Détecteur thermique",
    sig_flame: "Détecteur de flamme",
    sig_climate: "Climat de l'enceinte",
    sig_supervisory: "Supervision",
    sig_ebutton: "Bouton d'urgence",

    state_ok: "Sain",
    state_warn: "Avertissement",
    state_fault: "Défaut",
    state_unknown: "Inconnu",

    st_online: "EN LIGNE",
    st_offline: "HORS LIGNE",
    st_connected: "CONNECTÉ",
    st_down: "HORS SERVICE",
    st_lost: "PERDUE",
    st_standby: "EN VEILLE",
    st_onbattery: "SUR BATTERIE",
    st_normal: "NORMAL",
    st_tempalarm: "ALARME TEMP.",
    st_outofrange: "HORS PLAGE",
    st_unknown: "INCONNU",

    loading: "Chargement…",
    allsystemsok: "Tous les systèmes OK",
    faultneedsattention: "1 défaut nécessite une attention",
    faultsneedattention: "%{count} défauts nécessitent une attention",
    onewarning: "1 avertissement",
    warningscount: "%{count} avertissements",

    noreadingyet: "Aucun relevé pour l'instant",
    stalelastreading: "Obsolète · Dernier relevé %{time}",
    ago_seconds: "il y a %{count} s",
    ago_minutes: "il y a %{count} min",
    ago_hours: "il y a %{count} h",
    ago_days: "il y a %{count} j",

    networkerror: "Erreur réseau",
    serverresponded: "Le serveur a répondu %{status} %{text}",
    viewallsystems: "Voir les %{count} systèmes",
    nositesmatch: "Aucun site ne correspond à « %{query} »",
    lastupdatedtime: "Dernière mise à jour %{time}",
    dragtorotate: "Faites glisser pour pivoter · La zone en surbrillance indique l'emplacement du problème",
    awarenessonly: "À titre informatif uniquement · Contactez l'assistance FireRover pour toute intervention.",
    livereconnecting: "Reconnexion…",
    liveconnecting: "Connexion…",
    liveoffline: "Hors ligne"
  },

  'es-ES' :{
    telemetryunavailablefirstgen: "Lecturas de telemetría no disponibles para productos de primera generación",
    hidesitesnoreadings: "Ocultar sitios sin lecturas",
    nositeswithreadings: "No hay sitios con lecturas",
    allsystemsnormal: "Todos los sistemas normales",
    nowarningsorfaults: "No se informaron advertencias ni fallos.",
    nocurrentreadings: "Sin lecturas actuales",
    sitenotreportingtelemetry: "Este sitio aún no informa telemetría.",
    searching: "Buscando…",
    needsattention: "Requiere atención",
    plusmore: "+%{count} más",
    greeting: "Hola",
    welcome: "Bienvenido",
    welcometoportal: "Bienvenido al Portal de Clientes de",
    customerportal: "Portal del Web de",
    home: "Inicio",
    systems: "Sistemas",
    notifications: "Notificaciones",
    notificationsettings: "Configuración de notificaciones",
    editusersettings: "Editar configuración de usuario",
    nonotifications: "Sin notificaciones",
    managecontacts: "Gestionar contactos",
    sitemanagement: "Gestión del sitio",
    distributors: "Distribuidores",
    distributormanagement: "Gestión de distribuidores",
    customermaster: "Cliente principal",
    location: "Ubicación",
    invitedistributor: "Invitar distribuidor",
    revokedistributor: "Revocar distribuidor",
    revokedistributortitle: "¿Revocar distribuidor?",
    revokedistributortip: "Por favor, confirma que estás revocando a %{name} como distribuidor para %{master}.",
    errorrevokingdistributor: "Error al revocar el distribuidor. Por favor, inténtalo de nuevo.",
    failedaddingdistributor: "No se pudo agregar el distribuidor. Por favor, inténtalo de nuevo.",
    regiongroups: "Grupos de regiones",
    regiongroupname: "Nombre del grupo de regiones",
    noregiongroups: "Aún no hay grupos de regiones",
    create: "Crear",
    add: "Agregar",
    addsite: "Agregar sitio",
    adddistributor: "Agregar distribuidor",
    nodistributorsinregion: "No hay distribuidores en este grupo de regiones",
    deleteregiongroup: "Eliminar grupo de regiones",
    deleteregiongrouptitle: "¿Eliminar grupo de regiones?",
    deleteregiongrouptip: "Por favor, confirma que estás eliminando el grupo de regiones %{name}. Sus sitios quedarán sin asignar.",
    nositesinregion: "No hay sitios en este grupo de regiones",
    nodistributorsavailable: "No hay distribuidores disponibles",
    errorsavingregion: "Error al guardar los cambios. Por favor, inténtalo de nuevo.",
    account: "Cuenta",
    privacypolicy: "Política de privacidad",
    "privacy-policy": "Política de privacidad",
    settings: "Configuraciones",
    email: "Correo electrónico",
    emailaddress: "Correo electrónico",
    password: "Contraseña",
    rememberme: "Recuérdame",
    donthaveanaccount: "¿No tienes una cuenta?",
    alreadyhaveanaccount: "¿Ya tienes una cuenta?",
    signup: "Registrarse",
    signin: "Iniciar sesión",
    signout: "Cerrar sesión",
    back: "Atrás",
    done: "Hecho",
    usernameorpasswordincorrect: "Nombre de usuario o contraseña incorrectos. Inténtalo de nuevo.",
    passwordincorrect: "Contraseña incorrecta. Inténtalo de nuevo.",
    forgotpassword: "¿Olvidaste tu contraseña?",
    register: "Registrarse",
    name: "Nombre",
    phone: "Teléfono",
    firstname: "Nombre",
    lastname: "Apellido",
    timezone: "Zona horaria",
    selecttimezone: "Seleccionar zona horaria",
    save: "Guardar",
    saved: "Guardado",
    notificationssettingssaved: "¡Configuración de notificaciones guardada!",
    selectpreferredtimezone: "Seleccionar zona horaria preferida",
    onlyalphabet: "Solo se permiten caracteres alfabéticos.",
    entervalidphone: "Ingrese un número de teléfono válido.",
    enterregistrationcode: "Por favor, ingrese el código de registro de Fire Rover.",
    enteremailforresetcode: "Por favor, ingresa tu dirección de correo electrónico para recibir un código de restablecimiento.",
    registersuccess: "¡Registrado exitosamente!",
    registerfailed: "Error al registrar. Inténtalo de nuevo.",
    resetpassword: "Restablecer contraseña",
    reset: "Restablecer",
    enternewpassword: "Ingrese nueva contraseña",
    changepassword: "Cambiar contraseña",
    currentpassword: "Contraseña actual",
    newpassword: "Nueva contraseña",
    confirmpassword: "Confirmar contraseña",
    validatepassword: "Validar contraseña",
    passwordsdonotmatch: "Las contraseñas no coinciden.",
    registrationcode: "Código de registro",
    addregistrationcodes: "Agregar códigos de registro:",
    registrationcomplete: "¡Registro completo! Ahora serás redirigido a la página de inicio de sesión.",
    addcode: "Agregar código",
    validatecode: "Validar código",
    codevalidated: "Código validado",
    codeverified: "¡Código verificado!",
    codevalidatefailed: "Código inválido. Inténtalo de nuevo.",
    sendcode: "Enviar código",
    resendcode: "Reenviar código",
    phoneverificationcode: "Código de verificación telefónica",
    enterverificationcode: "Por favor, ingresa el código de verificación enviado a tu dispositivo móvil.",
    enteremailverificationcode: "Por favor, ingresa el código de verificación enviado a tu correo electrónico.",
    verificationcodesent: "¡Código de verificación enviado!",
    checkforverificationcode: "Por favor, revisa tus mensajes de texto para encontrar el código de verificación.",
    accountcreatedcheckforcode: "Tu cuenta ha sido creada, pero no recibirás notificaciones hasta que tu número de teléfono esté verificado.",
    verificationcodesentfailure: "Error al enviar el código de verificación. Por favor, inténtalo de nuevo.",
    emailisinvalid: "El correo electrónico no es válido.",
    passwordresetsuccess: "¡Contraseña restablecida con éxito!",
    passwordresetfailed: "No se pudo restablecer la contraseña. Inténtalo de nuevo.",
    passwordchangefailed: "No se pudo cambiar la contraseña. Inténtalo de nuevo.",
    passwordrequirementstxt: "La contraseña debe tener entre 8 y 26 caracteres, incluir al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
    contacts: "Contactos",
    nocontacts: "Sin contactos",
    invitecontactuser: "Invitar contacto",
    personalinformation: "Información personal",
    inputemail: "Ingresar correo electrónico",
    requestpasswordreset: "Solicitar restablecimiento de contraseña",
    search: "Buscar",
    sitesmanagement: "Gestión de sitios",
    sites: "Sitios",
    retrievingsites: "Recuperando sitios",
    retrievingnotifications: "Recuperando Notificaciones",
    nositesfound: "No se encontraron sitios",
    address: "Dirección",
    state: "Estado",
    units: "Unidades",
    unit: "Unidad",
    site: "Sitio",
    date: "Fecha",
    systemtime: "Hora del sistema",
    localtime: "Hora local",
    confirm: "Confirmar",
    cancel: "Cancelar",
    close: "Cerrar",
    delete: "Eliminar",
    promotetomanager: "Promover a administrador",
    promoteusertositemanager: "¿Promover al usuario a administrador del sitio?",
    promoteusertositemanagertip: "Por favor, confirma que estás promoviendo a %{name} como administrador de %{site}.",
    demotemanager: "Degradar administrador",
    demotemanagertouser: "Degradar administrador a usuario",
    demotesitemanagertouser: "¿Degradar al administrador del sitio a usuario?",
    demotesitemanagertousertip: "Por favor, confirma que estás degradando a %{name} al rol de usuario para %{site}.",
    deleteuser: "Eliminar usuario",
    removeuser: "Eliminar usuario",
    removeuserfromsite: "¿Eliminar al usuario del sitio?",
    removeuserfromsitetip: "Por favor, confirma que estás eliminando a %{name} de %{site}.",
    todcontrolinfo: "Información de control por hora del día",
    todcontrolinfotip: "Las configuraciones para días de semana y fines de semana son independientes y pueden ser iguales o diferentes.",
    on247: "Activado 24/7",
    on247info: "Recibirá notificaciones en tiempo real las 24 horas, todos los días.",
    off: "Desactivado",
    offinfo: "No recibirá notificaciones en ningún momento, sin importar la configuración de alertas.",
    onperschedule: "Activado según horario",
    accumulation: "Acumulación",
    accumulationinfo: "Las notificaciones recibidas fuera del horario se agruparán y entregarán al comienzo del siguiente periodo operativo.",
    startstop: "Iniciar/Detener",
    startstopinfo: "Las notificaciones recibidas fuera del horario no se entregarán pero se archivarán.",
    invitesent: "¡Invitación enviada!",
    invitefailed: "Error al enviar la invitación. Inténtalo de nuevo.",
    inviteuser: "Invitar a un usuario",
    invitecontactforsite: "Invitar contacto para el sitio",
    sendinvite: "Enviar invitación",
    testalert: "ALERTA DE PRUEBA",
    testalerts: "Alertas de prueba",
    hidetestalerts: "Ocultar alertas de prueba",
    fireroveractivated: "Fire Rover activado",
    accountmanager: "Administrador de cuenta",
    accountmanagerphone: "Teléfono del administrador de cuenta",
    centralstation: "Estación central",
    centralstationphone: "Teléfono de la estación central",
    servicedepartmentphone: "Teléfono del departamento de servicio",
    alertsiwanttoreceive: "Alertas que quiero recibir",
    verifiedfire: "Incendio verificado - Sistema preparado para intervención",
    suppressionactivated: "Supresión activada",
    mobilesuppressionunit: "Unidad móvil de supresión - Cambios de modo",
    alertdeliverymethods: "Métodos de entrega de alertas",
    fireroverappnotifications: "Notificaciones de la app FireRover",
    textnotifications: "Notificaciones de texto",
    whatsappnotifications: "Notificaciones de WhatsApp",
    pushnotifications: "Notificaciones push",
    emailnotifications: "Notificaciones por correo electrónico",
    wheniwanttoreceivealerts: "Cuándo quiero recibir alertas",
    weekdays: "Días de semana",
    weekends: "Fines de semana",
    starttime: "Hora de inicio",
    endtime: "Hora de finalización",
    preferredlanguage: "Idioma preferido",
    preferredlanguageNote: "*Afecta solo las notificaciones",
    selectpreferredlanguage: "Seleccionar idioma preferido",
    selectlanguage: "Seleccionar idioma",
    smsenabled: "Notificaciones de texto activado",
    messageratesmayapply: "Pueden aplicarse tarifas de mensajes y datos. Los SMS pueden no estar disponibles en su país.",
    whatsappconsenttitle: "Se requiere consentimiento de WhatsApp",
    whatsappconsenttip: "Para recibir alertas a través de WhatsApp, necesitamos su consentimiento para enviarle mensajes al número de teléfono registrado. Pueden aplicarse tarifas de mensajes y datos. Puede desactivar las notificaciones de WhatsApp en cualquier momento.",
    whatsappconsentcheckbox: "Doy mi consentimiento para recibir mensajes de Fire Rover a través de WhatsApp.",
    sendcodevia: "Enviar mi código de verificación por",
    textmessage: "Mensaje de texto",
    whatsapp: "WhatsApp",
    verifyphone: "Verificar teléfono",
    phoneverifiedsuccess: "Su número de teléfono está verificado.",
    phonenotverified: "Teléfono no verificado",
    phonenotverifiedwarning: "Su número de teléfono no está verificado. Haga clic aquí para verificarlo. Hasta que se verifique, no podemos garantizar que reciba los mensajes enviados por texto.",
    phoneverificationrequired: "Se requiere verificación del teléfono",
    registrationincomplete: "Su número de teléfono nunca se verificó, por lo que su registro no se completó. Regístrese de nuevo a continuación para recibir un nuevo código de verificación.",
    codeinvalidorexpired: "El código no es válido o ha expirado. Los códigos expiran 2 minutos después de enviarse.",
    phonenumbermismatch: "Este número de teléfono no coincide con el guardado en su cuenta. Guarde primero su nuevo número y luego solicite un código.",
    usernotfound: "No encontramos ninguna cuenta con esa dirección de correo electrónico.",
    sendcodeunexpected: "No pudimos solicitar un código. Comuníquese con soporte si el problema continúa.",
    verifyphoneprompt: "Envíe un código de verificación a su número de teléfono y luego ingréselo a continuación.",
    codesentcheckmessages: "Revise sus mensajes para obtener el código de verificación e ingréselo a continuación.",
    skipfornow: "Omitir por ahora",
    termsofservice: "Términos del servicio",
    accept: "Aceptar",
    english: "Inglés",
    french: "Francés",
    spanish: "Español",
    internalusers: "Usuarios internos",
    event: "Evento",
    showmore: "Mostrar más",
    send: "Enviar",
    actions: "Acciones",
    userdoesnotexist: "El usuario no existe. Por favor, inténtalo de nuevo.",
    rowsperpage: "Filas por página",
    noimage: "Sin Imagen",
    healthdashboard: "Panel de salud",
    alerts: "Alertas",
    overview: "Resumen",
    diagnostics: "Diagnóstico",
    viewallalerts: "Ver todas las alertas",
    unabletoloadalerts: "No se pudieron cargar las alertas",
    unabletoloadsystems: "No se pudieron cargar los sistemas",
    unabletoloadsites: "No se pudieron cargar los sitios",
    unabletoloaddetail: "No se pudieron cargar los detalles",
    searchbysiteorsystem: "Buscar por nombre de sitio o sistema",
    closealertsdrawer: "Cerrar el panel de alertas",
    closesystemsdrawer: "Cerrar el panel de sistemas",
    closesystemdetail: "Cerrar los detalles del sistema",

    // Material React Table
    and: 'y',
    changeFilterMode: 'Cambiar modo de filtro',
    changeSearchMode: 'Cambiar modo de búsqueda',
    clearFilter: 'Limpiar filtro',
    clearSearch: 'Limpiar búsqueda',
    clearSelection: 'Limpiar selección',
    clearSort: 'Limpiar orden',
    clickToCopy: 'Clic para copiar',
    copy: 'Copiar',
    collapse: 'Contraer',
    collapseAll: 'Contraer todo',
    columnActions: 'Acciones de columna',
    copiedToClipboard: 'Copiado al portapapeles',
    dropToGroupBy: 'Soltar para agrupar por {column}',
    edit: 'Editar',
    expand: 'Expandir',
    expandAll: 'Expandir todo',
    filterArrIncludes: 'Incluye',
    filterArrIncludesAll: 'Incluye todo',
    filterArrIncludesSome: 'Incluye',
    filterBetween: 'Entre',
    filterBetweenInclusive: 'Entre (inclusivo)',
    filterByColumn: 'Filtrar por {column}',
    filterContains: 'Contiene',
    filterEmpty: 'Vacío',
    filterEndsWith: 'Termina con',
    filterEquals: 'Igual a',
    filterEqualsString: 'Igual a',
    filterFuzzy: 'Aproximado',
    filterGreaterThan: 'Mayor que',
    filterGreaterThanOrEqualTo: 'Mayor o igual a',
    filterInNumberRange: 'Entre',
    filterIncludesString: 'Contiene',
    filterIncludesStringSensitive: 'Contiene',
    filterLessThan: 'Menor que',
    filterLessThanOrEqualTo: 'Menor o igual a',
    filterMode: 'Modo de filtro: {filterType}',
    filterNotEmpty: 'No vacío',
    filterNotEquals: 'Diferente de',
    filterStartsWith: 'Comienza con',
    filterWeakEquals: 'Igual a',
    filteringByColumn: 'Filtrando por {column} - {filterType} {filterValue}',
    goToFirstPage: 'Ir a la primera página',
    goToLastPage: 'Ir a la última página',
    goToNextPage: 'Ir a la página siguiente',
    goToPreviousPage: 'Ir a la página anterior',
    grab: 'Agarrar',
    groupByColumn: 'Agrupar por {column}',
    groupedBy: 'Agrupado por ',
    hideAll: 'Ocultar todo',
    hideColumn: 'Ocultar columna {column}',
    max: 'Máx',
    min: 'Mín',
    move: 'Mover',
    noRecordsToDisplay: 'No hay registros para mostrar',
    noResultsFound: 'No se encontraron resultados',
    of: 'de',
    or: 'o',
    pin: 'Fijar',
    pinToLeft: 'Fijar a la izquierda',
    pinToRight: 'Fijar a la derecha',
    resetColumnSize: 'Restablecer tamaño de columna',
    resetOrder: 'Restablecer orden',
    rowActions: 'Acciones de fila',
    rowNumber: '#',
    rowNumbers: 'Números de fila',
    select: 'Seleccionar',
    selectedCountOfRowCountRowsSelected: '{selectedCount} de {rowCount} fila(s) seleccionada(s)',
    showAll: 'Mostrar todo',
    showAllColumns: 'Mostrar todas las columnas',
    showHideColumns: 'Mostrar/Ocultar columnas',
    showHideFilters: 'Mostrar/Ocultar filtros',
    showHideSearch: 'Mostrar/Ocultar búsqueda',
    sortByColumnAsc: 'Ordenar por {column} ascendente',
    sortByColumnDesc: 'Ordenar por {column} descendente',
    sortedByColumnAsc: 'Ordenado por {column} ascendente',
    sortedByColumnDesc: 'Ordenado por {column} descendente',
    thenBy: ', luego por ',
    toggleDensity: 'Alternar densidad',
    toggleFullScreen: 'Alternar pantalla completa',
    toggleSelectAll: 'Alternar seleccionar todo',
    toggleSelectRow: 'Alternar selección fila',
    toggleVisibility: 'Alternar visibilidad',
    ungroupByColumn: 'Desagrupar por {column}',
    unpin: 'Desfijar',
    unpinAll: 'Desfijar todo',

    wt_step: "Paso %{current} / %{total}",
    wt_skip: "Omitir",
    wt_previous: "Anterior",
    wt_next: "Siguiente",
    wt_allset: "Listo",
    wt_replay: "Repetir el recorrido",
    wt_demo_event_title: "Spray-On",
    wt_demo_event_subtitle: "Sitio de ejemplo · Unidad 01",
    wt_demo_event_time: "Hoy, 09:42 (evento de ejemplo)",
    wt_welcome_title: "Bienvenido al portal",
    wt_welcome_body: "Haremos un breve recorrido por las pantallas que más usará. Puede omitirlo en cualquier momento.",
    wt_healthdashboard_title: "Panel de salud",
    wt_healthdashboard_body: "Comience aquí para ver el estado en vivo de sus sistemas. Las alertas que requieren atención aparecen arriba, y puede buscar cualquier sitio para revisar la conexión, la alimentación, el nivel de agente extintor y los detectores de un sistema.",
    wt_tile_title: "Mosaico de notificación",
    wt_tile_body: "Cada evento que envían sus sitios aparece como un mosaico como este, con el tipo, el sitio y la hora.",
    wt_image_title: "Imágenes del evento",
    wt_image_body: "Haga clic en la imagen de una notificación para ampliarla y verla en detalle.",
    wt_menu_title: "Menú principal",
    wt_menu_body: "Abra el menú lateral desde la esquina superior izquierda para moverse entre pantallas.",
    wt_distributors_title: "Gestión de distribuidores",
    wt_distributors_body: "Asigne los administradores a los sitios y regiones que supervisan para que luego puedan asignar a los usuarios responsables del monitoreo de esos sitios.",
    wt_managecontacts_title: "Administrar usuarios",
    wt_managecontacts_body: "Los administradores de sitio, usuarios internos y distribuidores pueden gestionar sus sitios y usuarios desde aquí.",
    wt_sitecontacts_title: "Usuarios del sitio",
    wt_sitecontacts_body: "Abra un sitio para ver las personas asociadas y ajustar quién recibe las notificaciones.",
    wt_account_title: "Su cuenta",
    wt_account_body: "Actualice su nombre, teléfono, zona horaria y contraseña aquí. También puede añadir códigos de registro.",
    wt_settings_title: "Ajustes de notificaciones",
    wt_settings_body: "Elija cómo le llega cada tipo de notificación. Desde aquí puede ajustar:",
    wt_settings_item1: "Notificaciones push en web y móvil",
    wt_settings_item2: "Notificaciones por correo electrónico",
    wt_settings_item3: "Notificaciones por SMS",
    wt_settings_item4: "Notificaciones de WhatsApp",
    wt_settings_item5: "Horas de silencio y preferencias por sitio",
    wt_settings_whatsapp_note: "Nota: los usuarios internacionales pueden tener dificultades para recibir alertas por SMS. Si se encuentra fuera de los Estados Unidos, considere elegir las notificaciones de WhatsApp para asegurarse de recibir sus mensajes de alerta.",
    wt_complete_title: "Todo listo",
    wt_complete_body: "Eso es todo por ahora. Puede repetir este recorrido desde la pantalla Cuenta cuando lo desee.",

    sig_monitoring: "Conexión de monitoreo",
    sig_primary: "Red principal",
    sig_cellular: "Respaldo celular",
    sig_ac: "Alimentación CA",
    sig_battery: "Batería de respaldo",
    sig_suppressant: "Nivel de agente extintor",
    sig_nitrogen: "Presión de nitrógeno",
    sig_thermal: "Detector térmico",
    sig_flame: "Detector de llama",
    sig_climate: "Clima del gabinete",
    sig_supervisory: "Supervisión",
    sig_ebutton: "Botón de emergencia",

    state_ok: "Correcto",
    state_warn: "Advertencia",
    state_fault: "Falla",
    state_unknown: "Desconocido",

    st_online: "EN LÍNEA",
    st_offline: "FUERA DE LÍNEA",
    st_connected: "CONECTADO",
    st_down: "CAÍDO",
    st_lost: "PERDIDA",
    st_standby: "EN ESPERA",
    st_onbattery: "CON BATERÍA",
    st_normal: "NORMAL",
    st_tempalarm: "ALARMA TEMP.",
    st_outofrange: "FUERA DE RANGO",
    st_unknown: "DESCONOCIDO",

    loading: "Cargando…",
    allsystemsok: "Todos los sistemas OK",
    faultneedsattention: "1 falla requiere atención",
    faultsneedattention: "%{count} fallas requieren atención",
    onewarning: "1 advertencia",
    warningscount: "%{count} advertencias",

    noreadingyet: "Sin lecturas aún",
    stalelastreading: "Obsoleto · Última lectura %{time}",
    ago_seconds: "hace %{count} s",
    ago_minutes: "hace %{count} min",
    ago_hours: "hace %{count} h",
    ago_days: "hace %{count} d",

    networkerror: "Error de red",
    serverresponded: "El servidor respondió %{status} %{text}",
    viewallsystems: "Ver los %{count} sistemas",
    nositesmatch: "Ningún sitio coincide con «%{query}»",
    lastupdatedtime: "Última actualización %{time}",
    dragtorotate: "Arrastre para rotar · El área resaltada muestra dónde está el problema",
    awarenessonly: "Solo informativo · Contacte al soporte de FireRover para servicio.",
    livereconnecting: "Reconectando…",
    liveconnecting: "Conectando…",
    liveoffline: "Fuera de línea"
  }
}
export { translations };